<template>
    <button class="button open-menu-button" @click="$emit('click')">
        <icon name="menu" class="button-icon"/>
    </button>
</template>

<script>
  import BaseButton from './Forms/BaseButton';
  import Icon       from './Layout/Icon';

  export default {
    name:       'OpenMenuButton',
    components: { Icon },
    extends:    BaseButton,

    props: {},

    data () {
      return {};
    },

    computed: {},

    methods: {},
  };
</script>

<style scoped>
    .open-menu-button {
        position:      relative;
        width:         4rem;
        height:        4rem;
        padding:       1rem;
        border-radius: 50%;
        background:    rgba(255, 255, 255, 0.5);
        color:         var(--color-primary);
    }

    .open-menu-button:hover,
    .open-menu-button:focus {
        background: var(--color-primary);
        color:      var(--color-white);
        box-shadow: none;
    }

    .open-menu-button .button-icon {
        padding-top: 2px;
        font-size:   1.6rem;
    }
</style>
